import React, { useEffect, useRef, useState} from 'react'
import {Row, Col, Form, Card, Button, Divider, Checkbox, Spin} from 'antd'
import { connect } from 'react-redux'

import InputField from 'components/InputField'
import TextAreaField from 'components/TextArea'
import SelectField from 'components/SelectField'
import FileUpload from 'components/fileUpload'

import {
    RefreshIco, MinusSmallIco, PlusSmallIco, SpinnerIco,
    EroorIco,
} from "../../../../../modules/CustomIcons"


import './index.scss'
import '../../transfer.scss'
import {OWNACCOUNT} from "constants/constants";
import {SelectOptions} from "../../../../services/form";
import {Account, getAccounts, getSavedDocuments} from "../../../../services/account";
import {getCurrentCompany, getUserData} from "../../../../services/user";
import {
    checkAmountForRequest,
    fillCurrentForm,
    financial,
    financialExchange,
    resetForm
} from "../../../../services/helper";
import AmountField from "components/AmountField";
import NextModal from "components/NextModal";
import {getExchangeDocumentNumber} from "../../../../services/Accounts/DocumentNumber";
import {makeExchange} from "../../../../services/Transfers/Exchange";
import TemplatePopup from "components/TemplatePopup";
import {getCustomerCommission} from "../../../../services/Customers/Commission";
import { calcRate } from '../../../../services/Transfers/CustomerRate'
import SaveAsTemplate from "components/SaveAsTemplate";
import {useLocation} from "react-router-dom";
import FullScreenLoading from "components/FullScreenLoading";
import {setIbanNumber } from "../../../../store/actions/accountStatement";
import { useActions } from 'hooks/useActions'
import { useTranslation } from 'react-i18next'



const sellBuyValueReset={
    SELLAMOUNT : '',
    PURCHAMOUNT : '',
}

const CurrencyExchange: React.FC<any> = ({ ibanNumber }) => {
    const {t} = useTranslation()
    const modalDataInitial={
        modalTitle : t("home.currencyExchange"),
        groups : [
            {
                title : false,
                data : []
            }
        ],
        pdfFiles : [],
        buttons : [
            {save : true},
            {sign : true},
            {approve : true},
            {send : true}
        ]
    };
    const [visible, setVisible] = useState(false);
    const [fromSelectOptions, setFromSelectOptions]=useState<SelectOptions[]>();
    const [toSelectOptions, setToSelectOptions]=useState<SelectOptions[]>();
    const [allAccounts, setAllAccounts]=useState<Account[]>();
    const [fromBranch, setFromBranch]=useState<Account>();
    const [toBranch, setToBranch]=useState<Account>();
    const [nextModalVisible, setNextModalVisible] = useState(false);
    const [templatePopupVisible, setTemplatePopupVisible] = useState(false);
    const [saveAsTemplatePopupVisible, setSaveAsTemplatePopupVisible] = useState<boolean>(false);
    const [modalData, setModalData] = useState(modalDataInitial);
    const [documentNumber, setDocumentNumber] = useState<string>('');
    const [disableBuyAmount, setDisableBuyAmount] = useState<boolean>(false);
    const [disableSellAmount, setDisableSellAmount] = useState<boolean>(false);
    const [showSpinner, setShowSpinner] = useState<boolean>(false);
    const [disableCalcBtn, setDisableCalcBtn] = useState<boolean>(true);
    const [bankDesc, setBankDesc] = useState<string>('')
    const [sellBuyValue, setSellBuyValue] = useState(sellBuyValueReset);
    const [showRate, setShowRate] = useState<number>();
    const [prefix, setPrefix] = useState<string>('');
    const [loadingAccount, setLoadingAccount] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const [ibankRef, setIbankRef] = useState<string>('');
    const [pdfCount, setPdfCount] = useState(0);
    const [fileList, setFileList] = useState<any[]>([])
    const [tableData, setTableData] = useState<any[]>([])
    const [editOrRepeat,setEdit] = useState(false)
    const [form] = Form.useForm();
    const location=useLocation();
    const { setIbanNumber } = useActions();

    const fetchData = async () => {
        setLoadingAccount(true)
        const data = await getAccounts(getCurrentCompany());

        let temp_data=[];

        for (let row of data ) {
            if(row.STATUS !== "0") {
                // @ts-ignore
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE)} ${row.CCY_NAME}`
                });
            }
        }


        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);

        /**/
        if (location?.state?.trnData){
            fillCurrentForm(form, location.state.trnData)
        }
        setLoadingAccount(false)
    };

    useEffect(() => {
        if (!allAccounts && location.state?.data === undefined){
            fetchData();
        }
    }, [sellBuyValue, location.state]);

    useEffect(() => {
        if(location.state?.data)
            loadData()
    }, [location.state]);

    const loadData = async () => {
        setLoadingData(true)
        setLoadingAccount(true)
        const data = await getAccounts(getCurrentCompany());

        let temp_data=[];

        for (let row of data ) {
            if(row.STATUS !== "0") {
                // @ts-ignore
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE)} ${row.CCY_NAME}`
                });
            }
        }
        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);
        /**/
        if (location?.state?.trnData){
            fillCurrentForm(form, location.state.trnData)
        }
        setLoadingAccount(false)
        const pdf = await getSavedDocuments(location.state?.data['ibankRef'])
        setFileList(pdf.data?.fileDetailsList)
        if (location.state?.edit){
            setEdit(true)
        }else{
            setEdit(false)
        }
        setTableData(location.state?.data)
        if(location.state?.edit)
            setIbankRef(location.state?.data['ibankRef'])
        setPdfCount(location.state?.data['attachedPDF'])
        // CUSTACC
            const findAccount = data?.find(row => row.IBAN == location.state?.data['CUSTACCFROM'] && row.STATUS !== "0");
            if(findAccount !== undefined) {
                setFromBranch(findAccount);
                const data1 = data?.filter(row => row.CCY_NAME!==findAccount?.CCY_NAME && row.IBAN!=findAccount?.IBAN && row.STATUS !== "0");

                let temp_data1=[];

                for (let row of data1 ){
                    // @ts-ignore
                    temp_data1.push({
                        label: row.IBAN,
                        value: row.IBAN,
                        extra: row.CCY_NAME
                    });
                }

                setToSelectOptions(old_data => temp_data1);

                if ((form.getFieldValue('PMTCUSTID') === "" || form.getFieldValue('PMTCUSTID') === undefined) && location.state?.edit === undefined) {
                    updateDocumentNumber();
                } else if(location.state?.edit) {
                    form.setFieldsValue({
                        'PMTCUSTID' : location.state?.data['PMTCUSTID']
                    });
                }
                form.setFieldsValue({
                    'CUSTACC' : location.state?.data['CUSTACCFROM']
                });
            }
            setSellBuyValue(old_data => sellBuyValueReset)
            setDisableBuyAmount(old_value => false);
            setDisableSellAmount(old_value => false);
            setShowRate(old_data => '');
            setBankDesc(old_data => '');
            setPrefix(old_data => '');
            form.resetFields(['SELLAMOUNT', 'PURCHAMOUNT', 'currencyRate', 'PMTDET']);

        // BENEFACC
            const findAccount1 = data?.find(row => row.IBAN == location.state?.data['CUSTACCTO'] && row.STATUS !== "0");
            if(findAccount1 !== undefined) {
                setToBranch(old_data => findAccount1);
                form.setFieldsValue({
                    'BENEFACC': location.state?.data['CUSTACCTO']
                });
            }
        // SELLAMOUNT
            if(location.state?.data['SELLAMOUNT'] !== undefined) {
                form.setFieldsValue({
                    'SELLAMOUNT': checkAmountForRequest(location.state?.data['SELLAMOUNT'])
                });
                setSellBuyValue(old_data => {
                    return {
                        ['SELLAMOUNT'] : checkAmountForRequest(location.state?.data['SELLAMOUNT'])
                    }
                });
                setDisableBuyAmount(old_value => true);
                setShowSpinner(old_data => true);
                const calc = await calcRate({
                    "CIF":  getCurrentCompany().customerNo,
                    "CUR1": findAccount?.CCY_NAME,
                    "AMOUNT1": form.getFieldValue('SELLAMOUNT') ? checkAmountForRequest(form.getFieldValue('SELLAMOUNT')) : null,
                    "CUR2":  findAccount1?.CCY_NAME,
                    "AMOUNT2":  null
                })
                setDisableCalcBtn(old_data => true);
                form.setFieldsValue({['PURCHAMOUNT'] : calc.AMOUNT});
                setSellBuyValue(old_data => ({
                    ...old_data,
                    ['PURCHAMOUNT'] : calc.AMOUNT
                }))
                setShowRate(old_value => (calc?.RATE1LEFTSUM + " " + calc?.RATE1LEFTCUR + " = " + calc?.RATE1RIGHTSUM + " " + calc?.RATE1RIGHTCUR + " / " + calc?.RATE2LEFTSUM + " " + calc?.RATE2LEFTCUR + " = " + calc?.RATE2RIGHTSUM + " " + calc?.RATE2RIGHTCUR))
                console.log(calc?.RATE1LEFTSUM)
                let sell_amount = financial(location.state?.data['SELLAMOUNT']),
                    purchase_amount = financial(calc.AMOUNT),
                    convert_exs = financial(1 / calc.RATE1RIGHTSUM);
                let text=`Satılan məbləğ ${sell_amount} ${findAccount?.CCY_NAME}, alınan məbləğ ${purchase_amount} ${findAccount1?.CCY_NAME} (məzənnə: ${calc?.RATE1LEFTSUM} ${calc?.RATE1LEFTCUR} - ${calc?.RATE1RIGHTSUM} ${calc?.RATE1RIGHTCUR}, ${calc?.RATE2LEFTSUM } ${calc?.RATE2LEFTCUR} - ${calc?.RATE2RIGHTSUM} ${calc?.RATE2RIGHTCUR})`
                form.setFieldsValue({'PMTDET': text});
                setBankDesc(old_data => text);
                setPrefix(old_data => text);
                setShowSpinner(old_data => false);
            }
        // NOTE
            form.setFieldsValue({'NOTE': location.state?.data['NOTE']}); 
        setLoadingData(false)
    }

    const updateDocumentNumber = async () => {
        const document_number = await  getExchangeDocumentNumber(getCurrentCompany());
        form.setFieldsValue({
            'PMTCUSTID' : document_number
        });

        setDocumentNumber(old_value => document_number)
    }

    const getSelectedFromBranch = (value:any) => {
        const findAccount=allAccounts?.find(row => row.IBAN==value);
        setFromBranch(findAccount);

        updateToSelectOption(findAccount);

        if (!form.getFieldValue('PMTCUSTID') && value){
            updateDocumentNumber();
        }

        resetSellAndBuyAmount();
    }

    useEffect(() => {
        if(ibanNumber.iban && allAccounts){
        const findAccount=allAccounts?.find(row => row.IBAN==ibanNumber.iban);
        setFromBranch(findAccount);
        updateToSelectOption(findAccount);
        if (!form.getFieldValue('PMTCUSTID') && ibanNumber.iban){
            updateDocumentNumber();
        }
        resetSellAndBuyAmount();
        
        setIbanNumber({iban: undefined, ccy_name: undefined})
        }

      }, [ibanNumber, allAccounts])

    const getSelectedToBranch = (value:any) => {
        const findAccount=allAccounts?.find(row => row.IBAN==value);
        setToBranch(old_data => findAccount);

        resetSellAndBuyAmount();
    }

    const updateToSelectOption = (findAccount) => {
        const data=allAccounts?.filter(row => row.CCY_NAME!==findAccount?.CCY_NAME && row.IBAN!=findAccount?.IBAN);

        let temp_data=[];

        for (let row of data ){

            // @ts-ignore
            temp_data.push({
                label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                value: row.IBAN,
                extra: row.CCY_NAME
            });
        }

        setToSelectOptions(old_data => temp_data);
    }
    
    const resetSellAndBuyAmount = () => {
        setSellBuyValue(old_data => sellBuyValueReset)
        setDisableBuyAmount(old_value => false);
        setDisableSellAmount(old_value => false);
        setShowRate(old_data => '');
        setBankDesc(old_data => '');
        setPrefix(old_data => '');
        form.resetFields(['SELLAMOUNT', 'PURCHAMOUNT', 'currencyRate', 'PMTDET']);
    }

    const sellBuyAmountHandleChange = (e) => {
        console.log(e.target.value);
        const {name, value} = e.target;
        setSellBuyValue(old_data => {
            return {
                [name] : value
            }
        });

       if (value!==''){
           if (name==='SELLAMOUNT'){

               setDisableBuyAmount(old_value => true);

           } else if(name==='PURCHAMOUNT'){
               setDisableSellAmount(old_value => true);
           }

           setDisableCalcBtn(old_data => false);

       } else {
           setDisableBuyAmount(old_value => false);
           setDisableSellAmount(old_value => false);

           setSellBuyValue(old_data => sellBuyValueReset)
           setShowRate(old_data => '');
       }
    }

useEffect(() => {
    setPdfCount(form.getFieldValue('pdf_files')?.length)
},[form.getFieldValue('pdf_files')])

    const newTransferFunc = (RequestType : string) => {
        let sell_amount=checkAmountForRequest(form.getFieldValue('SELLAMOUNT'));
        let purchase_amount=checkAmountForRequest(form.getFieldValue('PURCHAMOUNT'));
        let pdf_files=form.getFieldValue('pdf_files') ?? [];
        return makeExchange({
            trnRequestType : RequestType,
            ccy : 1,
            ccyType : fromBranch?.CCY_NAME,
            PMTCUSTID : form.getFieldValue('PMTCUSTID'),
            CUSTCIF: getCurrentCompany().customerNo,
            CUSTACCFROM : fromBranch?.IBAN,
            SELLAMOUNT: sell_amount,
            CUSTACCTO : toBranch?.IBAN,
            PURCHAMOUNT: purchase_amount,
            RATE: showRate,
            PMTDET: form.getFieldValue('PMTDET'),
            // COMMAMOUNT: 0,
            BENEFACCTYPE: form.getFieldValue('BENEFACCTYPE'),
            BENEFNAME: form.getFieldValue('BENEFNAME'),
            NOTE: form.getFieldValue('NOTE'),
            ibankRef: ibankRef,
            attachedPDF: pdfCount
        })
    }

    const submitHandler = (args: any) => {
        let sell_amount=financial(form.getFieldValue('SELLAMOUNT'));
        let purchase_amount=financial(form.getFieldValue('PURCHAMOUNT'));
        let pdf_files=form.getFieldValue('pdf_files') ?? [];
        modalDataInitial.pdfFiles=[];

        if (pdf_files.length > 0){

            for(let file of pdf_files){
                modalDataInitial.pdfFiles.push({
                    'label' : file.name,
                    'file' : file
                })
            }
        }

        setModalData(old_data => ({
            ...modalDataInitial,
            groups : [
                {
                    title : false,
                    data : [
                        {
                            label : t("transfers.sender"),
                            value :  getCurrentCompany().name
                        },
                        {
                            label : t("salary.documentNo"),
                            value : `${args.PMTCUSTID}`
                        },
                        {
                            label : t("transfers.fromAccount"),
                            value : `${fromBranch?.IBAN} ${fromBranch?.CCY_NAME}`
                        },
                        {
                            label : t("salary.toAccount"),
                            value :  `${toBranch?.IBAN} ${toBranch?.CCY_NAME}`
                        },
                        {
                            label : t("transfers.saleAmount"),
                            value :  `${sell_amount} ${fromBranch?.CCY_NAME}`
                        },
                        {
                            label : t("transfers.purchaseAmount"),
                            value :  `${purchase_amount} ${toBranch?.CCY_NAME}`
                        },
                        {
                            label : t("accountStatement.paymentDetails"),
                            value : `${args.PMTDET}`
                        },
                        args.NOTE !== undefined ? {
                            label : t("newTransfer.note"),
                            value : args.NOTE ?? ''
                        } : undefined,
                    ]
                }
            ]
        }))

        setNextModalVisible(old_value => true);
    }

    const getFileList = (info : any) => {
        form.setFieldsValue({
            'pdf_files' : info.fileList
        });
    }

    const calcRateFunc =  async () => {
        setShowSpinner(old_data => form.getFieldValue('SELLAMOUNT') || form.getFieldValue('PURCHAMOUNT'));

        const calc = await calcRate({
            "CIF":  getCurrentCompany().customerNo,
            "CUR1": fromBranch?.CCY_NAME,
            "AMOUNT1": form.getFieldValue('SELLAMOUNT') ? checkAmountForRequest(form.getFieldValue('SELLAMOUNT')) : null,
            "CUR2":  toBranch?.CCY_NAME,
            "AMOUNT2": form.getFieldValue('PURCHAMOUNT') ? checkAmountForRequest(form.getFieldValue('PURCHAMOUNT')) : null

        })


        let input_name=form.getFieldValue('SELLAMOUNT') ? 'PURCHAMOUNT' : 'SELLAMOUNT';

        setShowSpinner(old_data => false);
        setDisableCalcBtn(old_data => true);

        form.setFieldsValue({[input_name] : calc.AMOUNT});


        setSellBuyValue(old_data => ({
            ...old_data,
            [input_name] : calc.AMOUNT
        }))


        if (form.getFieldValue('SELLAMOUNT')) {

            // setShowRate(old_value => calc.RATE1RIGHTSUM);
            setShowRate(old_value => (calc.RATE1LEFTSUM + " " + calc.RATE1LEFTCUR + " = " + calc.RATE1RIGHTSUM + " " + calc.RATE1RIGHTCUR + " / " + calc.RATE2LEFTSUM + " " + calc.RATE2LEFTCUR + " = " + calc.RATE2RIGHTSUM + " " + calc.RATE2RIGHTCUR))

            makeDescription(calc.RATE2RIGHTSUM, calc.RATE1RIGHTSUM,calc.RATE1LEFTSUM,calc.RATE2LEFTSUM,calc.RATE1LEFTCUR,calc.RATE2LEFTCUR);

        } else{
            setShowRate(old_value => (calc.RATE1LEFTSUM + " " + calc.RATE1LEFTCUR + " = " + calc.RATE1RIGHTSUM + " " + calc.RATE1RIGHTCUR + " / " + calc.RATE2LEFTSUM + " " + calc.RATE2LEFTCUR + " = " + calc.RATE2RIGHTSUM + " " + calc.RATE2RIGHTCUR))

            // setShowRate(old_value => calc.RATE2RIGHTSUM);
            makeDescription(calc.RATE2RIGHTSUM, calc.RATE1RIGHTSUM,calc.RATE1LEFTSUM,calc.RATE2LEFTSUM,calc.RATE1LEFTCUR,calc.RATE2LEFTCUR);
        }
    }

    const makeDescription = (rate, rate1,rateleft1,rateleft2,rate1cur,rate2cur) => {
        let sell_amount=(form.getFieldValue('SELLAMOUNT')),
            purchase_amount=(form.getFieldValue('PURCHAMOUNT')),
            convert_exs=(rate);

        let text=`Satılan məbləğ ${sell_amount} ${fromBranch?.CCY_NAME}, alınan məbləğ ${purchase_amount} ${toBranch?.CCY_NAME} (məzənnə: ${rateleft1} ${rate1cur} - ${rate1} ${rate2cur}, ${rateleft2} ${rate2cur} - ${convert_exs} ${rate1cur})`
        //let text=`Satılan məbləğ - ${sell_amount} ${fromBranch?.CCY_NAME}, alınan məbləğ ${purchase_amount} ${toBranch?.CCY_NAME} (məzənnə: 1 ${toBranch?.CCY_NAME} = ${rate} ${fromBranch?.CCY_NAME} / 1 ${fromBranch?.CCY_NAME} = ${convert_exs} ${toBranch?.CCY_NAME})`;
        form.setFieldsValue({'PMTDET': text});
        setBankDesc(old_data => text);
        setPrefix(old_data => text);
    }

    const checkDescription = (e) => {
        let value = e.target.value;
        if(!value.startsWith(prefix)) {
            form.setFieldsValue({'PMTDET': prefix});
            setBankDesc(old_data => prefix);
        }
    }

    const openSaveAsTemplateModal = () => {

        setSaveAsTemplatePopupVisible(old_data => false)

        form.validateFields().then(res => {
            setSaveAsTemplatePopupVisible(old_data => true)

        }).catch(err_input_list => {

        })
    }

    const updateDocumentNumberAndCommission = () => {
        updateDocumentNumber();
    }

    let disable_inputs=(fromBranch?.ACCOUNT_NO===undefined && toBranch?.PRODUCT_NAME===undefined) || (fromBranch?.ACCOUNT_NO!==undefined && toBranch?.PRODUCT_NAME===undefined) || disableSellAmount;

    const removeFile = (index:any)=>{
        const myNewFiles = [...fileList]
        myNewFiles.splice(index, 1);
        setFileList(myNewFiles)
    }
    return (
        <>
            <Row className={'cur_exchange_bg'}>
                <Col flex={'700px'} className="own-account">
                    <Card bordered={false}>
                        <Row justify='start' className="own-account__form">
                            <Form
                                labelCol={{ flex: '190px'}}
                                wrapperCol={{ flex: 1 }}
                                className='full'
                                onSubmit={(e) => e.preventDefault(e)}
                                onFinish={submitHandler}
                                id={'form'}
                                form={form}
                                autoComplete="off"
                                scrollToFirstError={{
                                    behavior: 'smooth',
                                    block: 'center',
                                    inline: 'center',
                                }}
                            >

                                <InputField
                                    labelItem={t("salary.documentNo")}
                                    placeholder={t("salary.automatically")}
                                    name={'PMTCUSTID'}
                                    required={true}
                                    form={form}
                                    value={documentNumber}
                                    maxLength={25}
                                    allowLatinNumber ={true}
                                />

                                <SelectField
                                    labelItem={t("transfers.fromAccount")}
                                    placeholder={t("accountStatement.chooseAccount")}
                                    options={fromSelectOptions}
                                    name={'CUSTACC'}
                                    onChange={getSelectedFromBranch}
                                    required={true}
                                    form={form}
                                    account={true}
                                    notFoundContent={!loadingAccount ? t("newTransfer.noAccountCorrespondingCurrency") : undefined }
                                    defaultValue={ibanNumber.iban}
                                />

                                <SelectField
                                    labelItem={t("salary.toAccount")}
                                    placeholder={t("accountStatement.chooseAccount")}
                                    options={toSelectOptions}
                                    name={'BENEFACC'}
                                    required={true}
                                    onChange={getSelectedToBranch}
                                    form={form}
                                    disabled={!fromBranch?.ACCOUNT_NO}
                                    showSearch={true}
                                    className={'isDisabled'}
                                    notFoundContent={t("newTransfer.noAccountCorrespondingCurrency")}
                                />

                                <div  className={'flex align_center justify_between'} >
                                    <div className={'flex direction_column'}>
                                        <AmountField
                                            labelItem={t("transfers.saleAmount")}
                                            placeholder={''}
                                            suffix={fromBranch?.CCY_NAME}
                                            name={'SELLAMOUNT'}
                                            required={disableBuyAmount}
                                            form={form}
                                            limit={10}
                                            className={'not_show_required_props exchange_sell_buy_amount isDisabled'}
                                            disabled={disable_inputs}
                                            shouldUpdate={false}
                                            onChange={sellBuyAmountHandleChange}
                                            value={sellBuyValue.SELLAMOUNT}
                                        />

                                        <AmountField
                                            labelItem={t("transfers.purchaseAmount")}
                                            placeholder=""
                                            suffix={toBranch?.CCY_NAME}
                                            name={'PURCHAMOUNT'}
                                            required={disableSellAmount}
                                            form={form}
                                            limit={10}
                                            className={'not_show_required_props exchange_sell_buy_amount isDisabled'}
                                            disabled={ !(fromBranch?.ACCOUNT_NO && toBranch?.PRODUCT_NAME) || disableBuyAmount}
                                            onChange={sellBuyAmountHandleChange}
                                            value={sellBuyValue.PURCHAMOUNT}
                                        />
                                    </div>

                                    <Button
                                        size={'large'}
                                        htmlType="button"
                                        className="calculate-button blue-button btn flex align_center justify_center"
                                        disabled={(!disableBuyAmount && !disableSellAmount) || showSpinner || disableCalcBtn}
                                        onClick={calcRateFunc}
                                    >
                                        {
                                            showSpinner && <Spin className={'custom_spin_btn'} indicator={<SpinnerIco />} />
                                        }

                                        {t("newTransfer.calculate")}
                                    </Button>
                                </div>

                                <InputField
                                    labelItem={t("newTransfer.rate")}
                                    placeholder=""
                                    readOnly={true}
                                    value={showRate}
                                    name={'currencyRate'}
                                    form={form}
                                    className={'isReadOnly'}
                                    allowAllSymboll={true}
                                />

                                <TextAreaField
                                    visible={true}
                                    labelItem={t("accountStatement.paymentDetails")}
                                    placeholder=""
                                    showCount={true}
                                    maxLength={'140'}
                                    name={'PMTDET'}
                                    required={true}
                                    form={form}
                                    // readOnly={true}
                                    readOnly={!fromBranch?.ACCOUNT_NO && !toBranch?.PRODUCT_NAME}
                                    onChange={checkDescription}
                                    value={bankDesc}
                                    exchange={true}
                                    className={'isReadOnly'}
                                    prefix={prefix}
                                />

                                <div className={'flex'}>
                                    <Col flex={1}>
                                        <TextAreaField
                                            visible={visible}
                                            className='not-required plus_minus_area isReadOnly'
                                            labelItem={t("newTransfer.note")}
                                            placeholder={t("newTransfer.notTransferableToBank")}
                                            showCount={true}
                                            maxLength={'180'}
                                            form={form}
                                            name={'NOTE'}
                                            readOnly={!fromBranch?.ACCOUNT_NO && !toBranch?.PRODUCT_NAME}
                                            exchangeNote={true}
                                        />
                                    </Col>
                                    <Button
                                        className="icon-button add-remove-btn"
                                        icon={visible ? <MinusSmallIco /> : <PlusSmallIco />}
                                        onClick={() => setVisible(!visible)}
                                    />
                                </div>

                                <FileUpload
                                    className='file-upload isDisabled'
                                    labelItem={t("newTransfer.attachPDF")}
                                    form={form}
                                    name={'pdf_files'}
                                    onChange={getFileList}
                                    accept="application/pdf"
                                    multiple={false}
                                    required={false}
                                    fileLimit={10}
                                    checkSize={true}
                                    disabled={!fromBranch?.ACCOUNT_NO && !toBranch?.PRODUCT_NAME}
                                    editFileList={fileList}
                                    ibankRef={ibankRef}
                                    editOrRepeat={editOrRepeat}
                                    removeFile={removeFile}
                                />

                                <div  className='flex justify_end' >

                                    <div className={'flex flex_wrap button_row'}>


                                        <Button

                                            size={'large'}
                                            icon={<RefreshIco />}
                                            className="light-button refresh_btn btn flex align_center justify_center"
                                            onClick={(e) => { resetForm(form) }}
                                        >
                                            {t(OWNACCOUNT.REFRESH)}
                                        </Button>

                                        <Button
                                            size={'large'}
                                            htmlType="submit"
                                            className="blue-button next_btn btn flex align_center justify_center"
                                            disabled={!showRate}
                                        >
                                            {OWNACCOUNT.NEXT}
                                        </Button>
                                    </div>

                                </div>



                                {/* <div  className='flex tab_info_box justify_end' >
                                    <span className='passive_text_box passive_text_box_rel' >{t("newTransfer.requestForCurrency")}</span>
                                </div> */}

                            </Form>
                        </Row>
                    </Card>
                </Col>
            </Row>

            <NextModal
                errorIcon={<EroorIco />}
                callBackApi={newTransferFunc}
                visible={nextModalVisible}
                onClose={setNextModalVisible}
                currency
                data={modalData}
                className={'transfer_own_account'}
                nextModalTitle={t("home.currencyExchange")}
                nextModalText={`Əməliyyat uğurla saxlanılmış, imzalanmışdır və banka göndərilməsini gözləməkdədir.`}
                currentForm={form}
                transfer={true}
                repeatPdfList={fileList}
                tableData={tableData}
                editTransfer={ibankRef !== undefined && ibankRef !== '' && ibankRef !== null}
            />

            <TemplatePopup
                visible={templatePopupVisible}
                onClose={setTemplatePopupVisible}
                trnType={'EXCHANGE'}
                currentForm={form}
                updateAfterTemplate={updateDocumentNumberAndCommission}
            />

            <SaveAsTemplate
                visible={saveAsTemplatePopupVisible}
                onClose={setSaveAsTemplatePopupVisible}
                trnType={'EXCHANGE'}
                currentForm={form}
            />

            {
                loadingData ? <FullScreenLoading /> : <></>
            }

        </>
    )
}

const mapDispatchToProps = {setIbanNumber}

const mapStateToProps = (state: any) => ({
    ibanNumber: (state.accountsStatement && state.accountsStatement.ibanNumber) ? state.accountsStatement.ibanNumber : {}
});

export default connect(mapStateToProps, mapDispatchToProps)(CurrencyExchange)
